import InvoiceHomeDetailCard from "./InvoiceHomeDetailCard";
import { getInvoiceDetailsCardInfo } from "../invoice-master/invoice-helper";
import { RootState } from "src/context/store";
import { useSelector, useDispatch } from "react-redux";
import { useCallback, useEffect, useMemo, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { invoiceActions } from "src/context/invoice-slice";
import { fetchInvoicesData } from "src/services/invoice-api";
import { useToast } from "src/hooks/useToast";
import { Spinner } from "src/components";

const AllInvoices = ({ searchValue, searchCategory }: { searchValue?: string; searchCategory?: string }) => {
  const { invoiceData, invoiceAnalysisData } = useSelector((state: RootState) => state.invoice);
  const [hasMore, setHasMore] = useState(true);
  const { InvoiceFilters } = useSelector((state: RootState) => state.invoice);
  const [page, setPage] = useState(2);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { toast } = useToast();

//M10-9862
  // const resetFilter = () => {
  //   const hasActiveFilters = Object.values(InvoiceFilters).some((value: any) => value?.length > 0);

  //   if (hasActiveFilters) {
  //     dispatch(invoiceActions.setInvoiceFilters({ key: "company", value: [] }));
  //     dispatch(invoiceActions.setInvoiceFilters({ key: "division", value: [] }));
  //     dispatch(invoiceActions.setInvoiceFilters({ key: "stockist", value: [] }));
  //     dispatch(invoiceActions.setInvoiceFilters({ key: "status", value: [] }));
  //     dispatch(invoiceActions.setInvoiceFilters({ key: "assignee", value: [] }));
  //     dispatch(invoiceActions.setInvoiceFilters({ key: "city", value: [] }));
  //     dispatch(invoiceActions.setInvoiceFilters({ key: "district", value: [] }));
  //     dispatch(invoiceActions.setInvoiceFilters({ key: "state", value: [] }));
  //     dispatch(invoiceActions.setInvoiceFilters({ key: "fuidNo", value: [] }));
  //     dispatch(invoiceActions.setInvoiceFilters({ key: "sorting", value: [] }));
  //     dispatch(invoiceActions.setIsResetFilter(false));
  //   }
  // };

  const searchParams = useMemo(
    () => ({
      company_code: InvoiceFilters?.company?.map((item) => item.code)?.join(",") || "",
      division_code: InvoiceFilters?.division?.map((item) => item.company_divisioncode)?.join(",") || "",
      startDate: InvoiceFilters?.dateRange?.from,
      endDate: InvoiceFilters?.dateRange?.to,
      assignee_id: InvoiceFilters?.assignee?.map((item) => item.invoice_assignment_id)?.join(",") || "",
      city: InvoiceFilters?.city?.map((item) => item.city_name?.split("|")?.[0]?.trim())?.join(",") || "",
      district: InvoiceFilters?.district?.map((item) => item.district_name)?.join(",") || "",
      state: InvoiceFilters?.state?.map((item) => item.state_name)?.join(",") || "",
      ordering: InvoiceFilters?.sorting?.[0]?.key || "DESC",
      fuid_status_id: searchValue && searchValue?.length > 0 ? "" : InvoiceFilters?.status?.map((item) => item.fuid_status_id)?.join(",") || 1,
      page_size: 10,
      page_number: 1,
      screen: "Entry",
      dateType: InvoiceFilters?.dateType?.[0]?.key || "",
      ...(searchValue && searchCategory ? { [searchCategory]: searchValue } : {}),
      ...(searchValue ? {} : { is_escalated: false })
    }),
    [searchValue, searchCategory, InvoiceFilters]
  );

  const fetchTabData = useCallback(
    async () => {
      setIsLoading(true);
      dispatch(invoiceActions.setInvoiceDetails([]));
      dispatch(invoiceActions.setInvoicesTextractData([]));
      dispatch(invoiceActions?.setInvoiceMappingOrderData([]));
      dispatch(invoiceActions?.setInvoiceMappingOrderedProducts([]));
      dispatch(invoiceActions?.setInvoiceMappingOriginalDescriptions([]));
      window.localStorage.removeItem("counterCompanyLocationId");
      window.localStorage.removeItem("counterOrderId");
      try {
        const allInvoicesRes = await fetchInvoicesData(searchParams);
        dispatch(invoiceActions.setInvoiceData(allInvoicesRes?.data?.data?.invoiceData || []));
        if (allInvoicesRes?.data?.data?.total > 0 && invoiceAnalysisData?.entry?.["All Invoices"] > 0) {
          dispatch(invoiceActions.setInvoiceAnalysisData(
            {
              entry: {
                "All Invoices": allInvoicesRes?.data?.data?.total || 0,
                "Priority Tasks": invoiceAnalysisData?.entry?.["Priority Tasks"] || 0,
                "Escalated": invoiceAnalysisData?.entry?.["Escalated"] || 0,
              },
              approval: {
                "All Invoices": invoiceAnalysisData?.approval?.["All Invoices"] || 0,
                "Priority Tasks": invoiceAnalysisData?.approval?.["Priority Tasks"] || 0,
                "Escalated": invoiceAnalysisData?.approval?.["Escalated"] || 0,
              }
            }
          ));
        }
        dispatch(invoiceActions.setCurrentInvoiceIndex(0));
        dispatch(invoiceActions.setCurrentPageIndex(1));
        setPage(2);
        setHasMore(true);
        toast({ description: "Invoice data fetched successfully", variant: "default" });
      } catch (error) {
        console.error("Error fetching invoices data:", error);
        toast({ description: "Failed to fetch invoice data", variant: "destructive" });
      } finally {
        setIsLoading(false);
      }
    },
    [dispatch, searchParams]
  );

  const fetchMoreData = async () => {
    if (isLoading) return;
    try {
      const nextPageParams = { ...searchParams, page_number: page };
      const res = await fetchInvoicesData(nextPageParams);
      const newData = res?.data?.data?.invoiceData;
      if (!newData || newData.length === 0) {
        setHasMore(false);
        return;
      }
      dispatch(invoiceActions.setInvoiceData([...(invoiceData || []), ...newData]));
      dispatch(invoiceActions.setCurrentPageIndex(page));
      setPage((prev) => prev + 1);
    } catch (error) {
      console.error("Error fetching more invoices", error);
      setHasMore(false);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchTabData();
  }, [fetchTabData]);

  useEffect(() => {
    setPage(1);
    dispatch(invoiceActions.setInvoicesTextractData([]));
    //M10-9862
    // if (searchValue && searchValue?.trim()?.length > 0) {
    //   resetFilter();
    // }
  }, [searchValue]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-[50vh]">
        {" "}
        <Spinner />
      </div>
    );
  }

  return (
    <div className="mt-2 w-full pb-4">
      {invoiceData?.length === 0 && (
        <div className="flex justify-center items-center h-[20vh]">
          <p className="text-lg text-gray-500">No invoices found</p>
        </div>
      )}

      <div
        id="scrollableDiv"
        className="h-[calc(100vh-250px)] relative overflow-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100"
      >
        <InfiniteScroll
          dataLength={invoiceData?.length}
          next={fetchMoreData}
          hasMore={hasMore}
          loader={""}
          className="h-[60vh]"
          scrollableTarget="scrollableDiv"
          endMessage={<div className="py-4 text-center text-gray-500">No more invoices to load</div>}
          style={{ overflow: "hidden" }} // Prevents extra spacing when empty
        >
          {/* <ul className="flex flex-col gap-5 p-4 h-[100vh]"> */}
          {invoiceData?.map((data: any, index: number) => (
            <li className="rounded-xl border shadow-sm border-gray-200 list-none my-4" key={index}>
              <InvoiceHomeDetailCard
                status={data?.fileStatusHdr?.fuid_status_desc}
                data={getInvoiceDetailsCardInfo(data)}
                checkDataType={false}
                invoiceData={data}
                viewDetails={true}
                index={index}
                fetchTabData={fetchTabData}
              />
            </li>
          ))}
          {/* </ul> */}
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default AllInvoices;
